import * as Yup from 'yup';

import { checkIsSpam } from '~/src/utils/validation';

import { FormErrors } from '~/src/root.types';
import { FormName } from './form.types';

Yup.addMethod(Yup.string, 'businessEmail', function fn() {
  return this.test('business-email', FormErrors.BUSINESS_EMAIL, function test(value) {
    const { createError } = this;

    if (checkIsSpam(value)) {
      return createError({ message: FormErrors.BUSINESS_EMAIL });
    }

    return true;
  });
});

export const getValidationSchema = (hidePhone: boolean): Yup.AnyObjectSchema => Yup.object().shape({
  [FormName.FIRST_NAME]: Yup.string()
    .trim()
    .min(2, 'Last Name must be filled.')
    .required('First Name must be filled.'),
  [FormName.LAST_NAME]: Yup.string()
    .trim()
    .min(2, 'Last Name must be filled.')
    .required('Last Name must be filled.'),
  [FormName.EMAIL]: (Yup.string() as any)
    .trim()
    .email('Email must be filled.')
    .required('Email must be filled.')
    .businessEmail(),
  [FormName.COUNTRY]: Yup.string()
    .trim()
    .required('Country must be filled.'),
  [FormName.PHONE]: Yup.string()
    .trim()
    .min(9, 'Please specify valid phone number.')
    .test(
      'phoneRequired',
      'Phone Number must be filled',
      (value: string | undefined) => (!hidePhone ? !!value : true),
    ),
  [FormName.INDUSTRY]: Yup.string()
    .trim()
    .required('Industry must be filled.'),
  [FormName.MAU]: Yup.string()
    .trim()
    .required('MAU must be filled.'),
  [FormName.PUSHWOOSH_PRIVACY]: Yup.boolean()
    .oneOf([true], 'The Privacy Policy must be accepted.'),
  [FormName.PARTNER_PRIVACY]: Yup.boolean()
    .oneOf([true], 'The Partner Privacy Policy must be accepted.'),
});
